import '../../vendor/jquery.vimeo.api'
import '../../vendor/player'

export default {
    init() {
        /* Script for sequencing the video */
        if ($(".module-video-interactive")[0]) {
            var videoContent = $(".module-video-interactive");

            videoContent.find(".questions").click(
                function(event) {
                    videoContent.find(".questions").removeClass("selected-question");

                    $(this).addClass("selected-question");
                }
            );


            var iframe = videoContent.find('#seq');

            var running_time = 0;

            var player = new Vimeo.Player(iframe);

            //When the player is ready, set the volume to 1
            player.ready().then(function() {
                //player.setVolume(1);
                player.setVolume(0);
            });

            // Function to play a video in a specific interval (in seconds)
            window.getVideoQuestion = function(fromDuration, toDuration) {

                // Get the start duration and play the video
                iframe.vimeo("seekTo", fromDuration);
                iframe.vimeo("play");

                // Check if the end duration is exceeded
                var refreshIntervalId = window.setInterval(function() {
                    iframe.vimeo("getCurrentTime", function(data) {

                        running_time = data;
                        if (running_time > toDuration && running_time < toDuration + 2) {
                            iframe.vimeo("pause");
                            clearInterval(refreshIntervalId);
                        }
                    })
                }, 100);

            }
        }
    },
};